import React from "react";
import "./Info.css";
export default function Info() {
  return (
    <div className="info">
      <div className="program">
        <h1>PROGRAM</h1>

        <ul>
          <li>17:30 – 18:00 – Příchod</li>
          <li>18:00 – 18:30 – Uvítání a shrnutí úspěchů</li>
          <li>18:30 – 19:00 – I. Rautové občerstvení</li>
          <li>19:00 – 19:40 – Inspirace od úspěšných</li>
          <li>19:40 – 20:10 – II. Rautové občerstvení a networking</li>
          <li>20:10 – 20:40 – Zajímavá prohlídka prostorů hotelu Passage</li>
          <li>20:40 – 21:00 – Vyhlášení výherců tomboly</li>
        </ul>
      </div>
      <div className="informace">
        <h1>SMYSL AKCE</h1>
        <ul>
          <li>
            Společně se setkat, oslavit úspěchy a výsledky University of Applied
            Management
          </li>
          <li>
            Rozloučení se s University of Applied Management &{" "}
            <span>přivítání essential college</span>
          </li>
          <li>
            Udělat si příjemný večer a poznat nové{" "}
            <span>businessové příležitosti</span>
          </li>
          <li>
            Vyhrát v tombole úžasné ceny jako{" "}
            <span>iPad, iPods, luxusní hodinky značky Ingersoll</span> a mnoho
            dalšího - stačí pouze hodit vizitku do soutěžní nádoby
          </li>
        </ul>
      </div>
      <div className="organizace">
        <h1>ORGANIZAČNÍ ZÁLEŽITOSTI </h1>

        <ul>
          <li>
            Celá akce je bezplatná, <span>určená pouze pro zvané</span>{" "}
          </li>
          <li>Akce se koná v Brně, hotelu Passage, 24.9.2021</li>
          <li>
            Více informací naleznete v emailu ihned po registraci. Kdyby vám
            e-mail nepřišel do 1 minuty, kontaktujte nás na emailu{" "}
            <a href="mailto:info@essentialcollege.cz">
              info@essentialcollege.cz
            </a>{" "}
          </li>
        </ul>
      </div>
    </div>
  );
}
